import { ShiftPositionDetails } from '../../../../ui/features/shift-details/components/ShiftPositionDetails';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { showAlertDialog } from '@juvare/common-web-ui/DialogHelper';
import { Link, Typography } from '@mui/material';
import React from 'react';
const positionNameSx = { flexBasis: { xs: '60%', sm: '80%' } };
export const ShiftPositionName = ({ allowMissionChange, positionId, positionName, shiftId }) => {
    const { t } = useMissionsTranslation();
    if (!allowMissionChange) {
        return (React.createElement(Typography, { variant: 'body2', sx: positionNameSx, "data-test": 'name' }, positionName));
    }
    const showPositionDetailsDialog = () => {
        showAlertDialog({
            title: `${positionName} ${t('shifts.positionDetails.criteria')}`,
            closeLabel: t('common.close'),
            content: React.createElement(ShiftPositionDetails, { shiftId: shiftId, positionId: positionId }),
        });
    };
    return (React.createElement(Link, { variant: 'body2', sx: Object.assign(Object.assign({}, positionNameSx), { textAlign: 'left' }), "data-test": 'name', component: 'button', onClick: showPositionDetailsDialog }, positionName));
};
